import { SET_LOADING } from "../mutation-types";
import * as MUTATION_TYPES from "./mutation-types";
import * as GETTER_TYPES from "./getter-types";
import * as ACTION_TYPES from "./action-types";
import axios from "axios";
import setTypeDay from "../../utils/setTypeDay";

export const destiniesState = {
  destinies: {
    placesOptions: [],
    moreThanOneDayPlacesOptions: [],
    selectedDestiny: null,
    flights: [],
    trip: null
  }
};

export const destiniesGetters = {
  [GETTER_TYPES.GET_DESTINIES](state) {
    return state.destinies;
  },
  [GETTER_TYPES.GET_TOP_DESTINIES](state, getters) {
    return getters[GETTER_TYPES.GET_LOCATIONS]
    .flatMap(location => location.destinations)
    .filter(destination => destination?.pivot?.visible && destination.order)
    .filter((destination, index, arr) => {
      return arr.findIndex(d => d.id === destination.id) === index;
    })
    .sort((a, b) => (a.order > b.order ? 1 : -1))
    .slice(0, 6);
  },
  [GETTER_TYPES.GET_SELECTED_DESTINY](state) {
    return state.destinies.selectedDestiny;
  },
  [GETTER_TYPES.GET_LOCATIONS](state) {
    return state.destinies.placesOptions;
  },
  [GETTER_TYPES.GET_FLIGHTS](state) {
    return state.destinies.flights;
  },
  [GETTER_TYPES.GET_TRIP](state) {
    return state.destinies.trip;
  },
  [GETTER_TYPES.GET_TYPE_DATES](state, getters) {
    return getters[GETTER_TYPES.GET_FLIGHTS].map((days, index) => {
      if (days[1] && days[1][0]) {
        const price = days[1][0].price;
        const type = setTypeDay(price, state.destinies.trip);
        return {
          id: index,
          day: days[0],
          price: price.toFixed(2),
          type: type
        };
      }
    }).filter(Boolean);
  },
  [GETTER_TYPES.GET_ORIGINS_OPTIONS](state, getters) {
    return getters[GETTER_TYPES.GET_FORMATTED_OPTIONS](state.destinies.placesOptions);
  },
  [GETTER_TYPES.GET_MORE_THAN_ONE_DAY_ORIGINS_OPTIONS](state, getters) {
    return getters[GETTER_TYPES.GET_FORMATTED_OPTIONS](state.destinies.moreThanOneDayPlacesOptions);
  },
  [GETTER_TYPES.GET_FORMATTED_OPTIONS]: state => options => {
    return options
      .filter(location => {
        if (location.destinations) {
          return location.destinations.some(destination => destination.pivot.visible);
        } else {
          return true;
        }
      })
      .map(location => {
        return {
          id: location.id,
          code: location.code,
          label: location.name,
          name: location.name
        };
      });
  },
  [GETTER_TYPES.GET_DESTINIES_OPTIONS](state) {
    if (state.search.origin && state.destinies.placesOptions) {
      const origin = state.destinies.placesOptions.find(
        option => option.id === state.search.origin.id
      );
      if (origin && origin.destinations && origin.destinations.length > 0) {
        const destiniesOptions = origin.destinations
          .filter(destination => {
            return destination.pivot.visible;
          })
          .map(location => {
            return {
              id: location.id,
              code: location.code,
              minPrice: parseFloat(location.minPrice),
              label: location.name,
              name: location.name
            };
          });
        return destiniesOptions;
      }
    }
    return [];
  },
  [GETTER_TYPES.GET_DESTINIES_IMAGES](state) {
    return state.destinies.placesOptions
      .flatMap(location => location.destinations)
      .concat(state.destinies.placesOptions)
      .reduce(
        (prev, curr) => {
          if (!curr) return prev;
          const image = curr.results_thumbnail_image;
          const flight = state.destinies.flights.find(flight => flight.cityCodeTo === curr.code && flight.airportTo !== flight.cityCodeTo);

          return {
            ...prev,
            [curr.code]: image,
            ...(flight && { [flight.airportTo]: image })
          };
        },
        {}
      );
  }
};

export const destiniesMutations = {
  [MUTATION_TYPES.PLACES_SUCCESS](state, { oneDay, moreThanOneDay }) {
    state.destinies.placesOptions = [...oneDay];
    state.destinies.moreThanOneDayPlacesOptions = [...moreThanOneDay];
  },
  [MUTATION_TYPES.PLACE_SUCCESS](state, payload) {
    state.search.destiny = payload.selected;
    state.destinies = {
      placesOptions: [...payload.locations],
      selectedDestiny: payload.selected,
      flights: []
    };
  },
  [MUTATION_TYPES.SET_FLIGHTS](state, payload) {
    if(!Array.isArray(payload)) payload = Object.values(payload);

    state.destinies.flights = [...payload];
  },
  [MUTATION_TYPES.FLIGHTS_SUCCESS](state, payload) {
    state.destinies.flights = [...payload];
    state.loading = false;
  },
  [MUTATION_TYPES.TRIP_SUCCESS](state, payload) {
    state.destinies.trip = payload;
  },
  [MUTATION_TYPES.UPDATE_FLIGHT](state, payload){
    state.destinies.flights[payload.index][1][0].price = payload.price;
  }
};

export const destiniesActions = {
  async [ACTION_TYPES.FETCH_PLACES]({ commit, state }) {
    const [oneDay, moreThanOneDay] = await Promise.all([
      axios.get("/api/locations"),
      axios.get("/api/locations/more-than-one-day"),
    ]);
    commit(MUTATION_TYPES.PLACES_SUCCESS, {
      oneDay: oneDay.data,
      moreThanOneDay: moreThanOneDay.data,
    });
  },
  async [ACTION_TYPES.FETCH_PLACE]({ commit, state }, slug) {
    const data = await axios.get("/api/locations/" + slug + "/origins");
    if (data.status === 200) {
      commit(MUTATION_TYPES.PLACE_SUCCESS, {
        locations: data.data.map(location => location.origin),
        selected: data.data[0].destination
      });
      return data.data[0].destination;
    }
    return false;
  },
  async [ACTION_TYPES.FETCH_FLIGHTS]({ commit, state }, payload) {
    commit(SET_LOADING, true);

    return fetch(`/api/flights/${payload.origin}/${payload.destiny}?adults=${payload.adults}&children=${payload.children}&infants=${payload.babies}`)
      .then(res => {
        return res.json();
      })
      .then(data => {

        commit(MUTATION_TYPES.FLIGHTS_SUCCESS, Object.entries(data));
      })
      .catch(error => {
        console.log('error fetching flights', error);
        throw new Error(error);
      });
  },
  async [ACTION_TYPES.FETCH_TRIPS]({ commit, state }, payload) {
    commit(SET_LOADING, true);

    return fetch(`/api/trips/${payload.origin}/${payload.destiny}`)
      .then(res => {
        return res.json();
      })
      .then(data => {
        commit(MUTATION_TYPES.TRIP_SUCCESS, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  // TODO: mergear con FETCH_FLIGHTS
  async [ACTION_TYPES.FETCH_DESTINIES]({ commit, state }, payload) {
    commit(SET_LOADING, true);

    axios.interceptors.request.use(res => {
      res.meta = res.meta || {};
      res.meta.requestStartedAt = new Date().getTime();
      return res;
    });

    axios.interceptors.response.use(res => {
      res.responseTime =
        new Date().getTime() - res.config.meta.requestStartedAt;
      return res;
    });

    let endpoint = `/api`;
    if (payload.origin) {
      endpoint += `/flights/${payload.origin}`;
      if (payload.date) {
        endpoint += `?date=${payload.date}&adults=${payload.adults}&children=${payload.children}&infants=${payload.babies}`;
      }
    } else {
      endpoint += "/destinations-one-day";
    }

    return axios
      .get(endpoint)
      .then(response => {
        const timeout =
          response.responseTime < 1000 ? 2000 - response.responseTime : 0;

        if (payload.origin) {
          const flights = response.data;
          commit(MUTATION_TYPES.SET_FLIGHTS, flights);
        } else {
          const flights = response.data.map(flight => {
            return {
              locationId: flight.destination_id,
              code: flight.destination.code,
              image: flight.destination.results_thumbnail_image,
              alt_image: flight.destination.results_thumbnail_alt,
              title: flight.destination.name,
              price: parseFloat(flight.price_from),
              slug: flight.destination.slug,
              cityCodeTo: flight.destination.code,
            };
          });
          commit(MUTATION_TYPES.SET_FLIGHTS, flights);
        }

        setTimeout(() => {
          commit(SET_LOADING, false);
        }, timeout);
      })
      .catch(error => {
        commit(SET_LOADING, false);
        throw new Error(error);
      });
  },
  async [ACTION_TYPES.FETCH_DESTINIES_OPTIONS_FROM_ORIGIN](
    { commit, state },
    payload
  ) {
    return state.destinies.placesOptions.find(option => option.id === payload);
  },
  //checkout wizard
  //TODO: departureToken/BookingToken
  async [ACTION_TYPES.CHECK_TRIP]({ commit, state }, payload) {
    let urlApiFlights = `/api/flights/${payload.origin}/${payload.destiny}?date=${payload.date}&adults=${payload.adults}&children=${payload.children}&infants=${payload.babies}`;
    if(payload.departureToken) urlApiFlights += `&departureToken=${payload.departureToken}`;

    return axios
      .get(urlApiFlights)
      .then(response => {
        if (response.data.length > 0) {
          return response.data;
        } else {
          throw new Error();
        }
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};
